import React from 'react'

const Gear = (props) => (
  <svg width={20} height={21} viewBox="0 0 20 21" {...props}>
    <g strokeWidth={2} fill="none" fillRule="evenodd">
      <path d="M10.444 13.333a2.26 2.26 0 002.251-2.266A2.26 2.26 0 0010.444 8.8a2.26 2.26 0 00-2.252 2.267 2.26 2.26 0 002.252 2.266z" />
      <path d="M11.005 17.624c-.31-.213-.812-.213-1.122 0L7.945 18.95c-.31.212-.645.088-.75-.279l-.649-2.287c-.104-.366-.5-.698-.86-.737l-2.319-.256c-.37-.041-.55-.356-.398-.706l.942-2.178c.15-.35.064-.854-.195-1.13L2.101 9.66c-.259-.275-.198-.633.138-.802l2.094-1.05c.335-.168.586-.612.56-.993l-.155-2.377c-.025-.38.26-.611.61-.523l2.266.57c.362.09.834-.084 1.055-.393l1.376-1.923c.22-.307.577-.308.798 0l1.376 1.923c.22.308.704.48 1.055.392l2.265-.57c.362-.09.636.143.61.524l-.155 2.377c-.025.38.225.824.561.993l2.093 1.05c.335.168.398.527.139.802l-1.615 1.719c-.259.274-.347.779-.195 1.129l.942 2.178c.15.349-.04.666-.399.706l-2.319.256c-.37.04-.755.37-.86.737l-.649 2.287c-.104.366-.439.492-.75.279l-1.937-1.326z" />
    </g>
  </svg>
)

export default Gear
